<template>
  <span class="flag flag-icon" :class="className" :alt="country" :title="country" />
</template>

<script>
  export default {
    name: 'Flag',
    props: {
      country: {
        type: String,
        required: true,
      },
    },
    computed: {
      className() {
        return `flag-icon-${this.country.toLowerCase()}`
      },
    },
  }
</script>
